import Api from './api'

const urlPath = "authenticate"

export default {
    //GET
    authenticate: ({email, password}) => Api.GET(urlPath, {email, password}),

    //POST


    //PUT

}